import React, {useEffect, useState} from 'react';

import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

import Score from '@Themes/natucare/modules/Score/Score';

import FeedbackApi from '@/components/FeedbackApi/FeedbackApi';

import DATA from '@/data/common.data';

import {getVotes} from './api/getVotes';
import {sendVote} from './api/sendVote';

const ScoreApi = props => {
  const [votes, setVotes] = useState(+props.votes);
  const [score, setScore] = useState(+props.score);
  const [hasVoted, setHasVoted] = useState(false);
  const [feedbackState, setFeedbackState] = useState({
    open: false,
    type: ''
  });

  const localStorageKeyName = props.request_uri;

  const handleStarClick = async event => {
    if (localStorage.getItem(localStorageKeyName)) {
      setHasVoted(true);
    } else {
      const value = event.currentTarget.dataset.value;
      localStorage.setItem(localStorageKeyName, JSON.stringify({value: value}));

      sendVote(2, props.request_uri, value)
        .then(response => {
          if (response.ok) {
            getVotes(2, props.request_uri)
              .then(result => {
                setVotes(result.votes);
                setScore(result.score);

                setFeedbackState({
                  open: true,
                  type: value >= 3 ? FEEDBACK_CONSTANTS.POSITIVE_MODAL_KEY : FEEDBACK_CONSTANTS.NEGATIVE_MODAL_KEY
                });
              })
              .catch(error => {
                console.error(error);
              });
          }
        });
    }
  };

  useEffect(() => {
    getVotes(2, props.request_uri)
      .then(result => {
        setVotes(result.votes);
        setScore(result.score);
      })
      .catch(error => {
        console.error(error);
      });

  }, [props.request_uri]);

  return <>
    <Score
      votes={+votes}
      score={+score}
      onStarClick={handleStarClick}
      hasVoted={hasVoted}
      i18n={{
        heading: DATA[props.locale].score.heading,
        message: DATA[props.locale].score.message,
        votes: DATA[props.locale].score.votes(+votes),
        score: DATA[props.locale].score.score,
      }}
    />
    <FeedbackApi
      locale={props.locale}
      requestUri={props.request_uri}
      hideButton={true}
      state={feedbackState}/>
  </>;
};

export default ScoreApi;
